import React from 'react';
import { Helmet } from 'react-helmet-async';

const ROBOTS = 'noindex, nofollow';

/**
 * Métadonnées pour pages non destinées à l’indexation (auth, légal, etc.).
 */
export default function NonIndexableHelmet({ title, description }) {
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <meta name="robots" content={ROBOTS} />
      <meta name="googlebot" content={ROBOTS} />
    </Helmet>
  );
}
